"use client";

import { enableMapSet } from "immer";
import { useEffect } from "react";

// Initialize Immer with MapSet support
enableMapSet();

export function ImmerInit() {
	useEffect(() => {
		// Additional initialization if needed
	}, []);

	return null;
}
